<template>
    <SbsModal
        v-model="modalModel"
        class="ConfirmModal"
        modalContainerClass="ConfirmModalContainer"
        zIndex="1000"
        :maxWidth="maxWidth">
        <template #closeButton>
            <InlineSvg
                class="ConfirmModal__CloseBtn"
                :src="require('@/assets/svg/ic_close.svg')" />
        </template>
        <div class="ConfirmModal">
            <slot name="prepend"></slot>
            <slot name="label">
                <h4
                    v-html="label"
                    class="ConfirmModal__Title"></h4>
            </slot>
            <p
                v-if="subLabel"
                v-html="subLabel"
                class="ConfirmModal__Subtitle">
            </p>
            <slot name="additionalContent"></slot>
            <div class="ConfirmModal__Actions">
                <SbsButton
                    class="ConfirmModal__ActionsButton"
                    :bordered="false"
                    backgroundTheme="primary"
                    colorTheme="white"
                    :size="btnSize"
                    :text="buttonRemoveTitle"
                    :loading="loading"
                    static
                    fullWidth
                    @click="handleConfirm" />
                <SbsButton
                    class="ConfirmModal__ActionsButton"
                    backgroundTheme="gray-ultra-light"
                    borderTheme="gray"
                    colorTheme="black"
                    :size="btnSize"
                    :text="buttonCancelTitle"
                    :disabled="loading"
                    bordered
                    static
                    fullWidth
                    @click="handleCancel" />
            </div>
        </div>
        <SbsCheckbox
            v-if="hasShowAgainNote"
            v-model="notShowAgain"
            class="ConfirmModal__Checkbox"
            hoverBackground="transparent"
            hoverColor="gray-deep"
            controlTheme="gray-ultra-light"
            :label="showAgainNote" />
    </SbsModal>
</template>

<script>
import InlineSvg from 'vue-inline-svg';

export default {
    name: 'ConfirmModal',
    components: { InlineSvg },
    emits: ['update:modelValue', 'confirm', 'cancel', 'close'],
    data() {
        return {
            notShowAgain: false,
        };
    },
    computed: {
        modalModel: {
            get() {
                return this.modelValue;
            },
            set(value) {
                if (this.loading) return;

                this.$emit('update:modelValue', value);

                if (!value) {
                    this.$emit('close', this.notShowAgain);
                }
            },
        },
    },
    methods: {
        handleConfirm() {
            this.$emit('confirm', this.notShowAgain);
        },
        handleCancel() {
            this.$emit('cancel', this.notShowAgain);
        },
    },
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: '',
            required: true,
        },
        subLabel: {
            type: String,
            default: '',
        },
        showAgainNote: {
            type: String,
            default: 'Не показывать больше',
            required: false,
        },
        hasShowAgainNote: {
            type: Boolean,
            default: false,
        },
        buttonRemoveTitle: {
            type: String,
            default: 'Да, выйти',
        },
        buttonCancelTitle: {
            type: String,
            default: 'Нет, я передумал-(а)',
        },
        loading: {
            type: Boolean,
            default: false,
        },
        btnSize: {
            type: String,
            default: 'medium',
        },
        maxWidth: {
            type: [Number, String],
            default: 627,
        },
    },
};
</script>

<style lang="scss" scoped>
.ConfirmModal {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.ConfirmModal__Title {
    text-align: center;

    @include typo-h3-bold;
}

.ConfirmModal__Subtitle {
    margin-top: 10px;
    text-align: center;

    @include typo-additional-book;
}

.ConfirmModal__Actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
    width: 100%;
    margin-top: 20px;
}
</style>

<style lang="scss">
.ConfirmModal__CloseBtn {
    width: 24px;
    height: 24px;

    path {
        fill: #bec4cf;
    }

    &:hover {
        opacity: 0.7;
    }
}

.ConfirmModal__Checkbox {
    margin-top: 30px;
    padding-top: 20px;
    border-top: 1px solid $gray-light;

    .sbs-checkbox__item {
        align-items: flex-start;
        padding: 0;
    }

    .sbs-checkbox__control-wrapper {
        padding-top: 4px;
    }

    .sbs-checkbox__control {
        width: 20px;
        height: 20px;
    }
}

.ConfirmModalContainer {
    z-index: 200;
}
</style>
